// #region 厂商联
// 厂商联 生产模式
export const factoryProductionMode = [
  { id: 0, value: '', label: '全部', tip: '全部' },
  { id: 1, value: 'OEM', label: 'OEM', tip: '原始设备制造商' },
  { id: 2, value: 'OBM', label: 'OBM', tip: '原始品牌制造商' },
  { id: 3, value: 'ODM', label: 'ODM', tip: '原始设计制造商' },
  { id: 4, value: 'CMT', label: 'CMT', tip: '来料加工' },
  { id: 5, value: 'Other Modes(其他模式)' },
];

// 厂商联 年交易额
export const tradeAmountYearly = [
  { id: 0, value: '', label: '全部', tip: '全部' },
  { id: 1, value: '3000万以下', label: '3000万以下' },
  { id: 2, value: '3000万~6000万', label: '3000万~6000万' },
  { id: 3, value: '6000万~9000万', label: '6000万~9000万' },
  { id: 4, value: '9000万~2亿', label: '9000万~2亿' },
  { id: 5, value: '2亿~5亿', label: '2亿~5亿' },
  { id: 6, value: '5亿~10亿', label: '5亿~10亿' },
  { id: 7, value: '10亿~20亿', label: '10亿~20亿' },
  { id: 8, value: '20亿以上', label: '20亿以上' },
];

// 厂商联 员工人数
export const employeesNumber = [
  { id: 0, value: '', label: '全部', tip: '全部' },
  { id: 1, value: '1~50人', label: '1~50人' },
  { id: 2, value: '51~150人', label: '51~150人' },
  { id: 3, value: '151~500人', label: '151~500人' },
  { id: 4, value: '501~1000人', label: '501~1000人' },
  { id: 5, value: '1001~5000人', label: '1001~5000人' },
  { id: 6, value: '5001人以上', label: '5001人以上' },
];

// 厂商联 生产人数
export const productionNumber = [
  { id: 0, value: '', label: '全部', tip: '全部' },
  { id: 1, value: '1~20人', label: '1~20人' },
  { id: 2, value: '21~50人', label: '21~50人' },
  { id: 3, value: '51~100人', label: '51~100人' },
  { id: 4, value: '101~500人', label: '101~500人' },
  { id: 5, value: '501~1000人', label: '501~1000人' },
  { id: 6, value: '1001人以上', label: '1001人以上' },
];

// 厂商联 月产值
export const amountProductMonthly = [
  { id: 0, value: '', label: '全部', tip: '全部' },
  { id: 1, value: '300万以下', label: '300万以下' },
  { id: 2, value: '300万~500万', label: '300万~500万' },
  { id: 3, value: '500万~1000万', label: '500万~1000万' },
  { id: 4, value: '1000万~5000万', label: '1000万~5000万' },
  { id: 5, value: '5000万~1亿', label: '5000万~1亿' },
  { id: 6, value: '1亿~5亿', label: '1亿~5亿' },
  { id: 7, value: '5亿以上', label: '5亿以上' },
];

// 厂商联 产品质量认证
export const identificationProductQuality = [
  { id: 0, value: '', label: '全部', tip: '全部' },
  { id: 1, value: 'CCC', label: 'CCC' },
  { id: 2, value: 'TUV', label: 'TUV' },
  { id: 3, value: 'Emark', label: 'Emark' },
  { id: 4, value: 'CMA', label: 'CMA' },
  { id: 5, value: 'CE', label: 'CE' },
  { id: 6, value: 'ROHS', label: 'ROHS' },
  { id: 7, value: 'ELV', label: 'ELV' },
  { id: 8, value: 'GS', label: 'GS' },
  { id: 9, value: 'Other Certification（其他认证）', label: 'Other Certification（其他认证）' },
];

// 厂商联 管理体系认证
export const identificationManageSystem = [
  { id: 0, value: '', label: '全部', tip: '全部' },
  { id: 1, value: 'ISO9001', label: 'ISO9001' },
  { id: 2, value: 'ISO14001', label: 'ISO14001' },
  { id: 3, value: 'IATF16949', label: 'IATF16949' },
  { id: 4, value: 'ISO10012', label: 'ISO10012' },
  { id: 5, value: 'TS16949', label: 'TS16949' },
  { id: 6, value: 'OHSAS18001', label: 'OHSAS18001' },
  { id: 7, value: 'ISO45001', label: 'ISO45001' },
  { id: 8, value: 'Other Certification（其他认证）', label: 'Other Certification（其他认证）' },
];

// 厂商联 加工方式
export const processMode = [
  { id: 0, value: '', label: '全部', tip: '全部' },
  { id: 1, value: '来图加工', label: '来图加工' },
  { id: 2, value: '来样加工', label: '来样加工' },
  { id: 3, value: '包工包料', label: '包工包料' },
  { id: 4, value: '其他加工', label: '其他加工' },
];

// 厂商联 平台求购信息-求购状态
export const seekPurchaseStatus = [
  { id: 0, value: '0', label: '全部', statsKey: 'all' },
  { id: 1, value: '1', label: '接单中', statsKey: 'receivingNum' },
  { id: 2, value: '2', label: '洽谈中', statsKey: 'negotiationingNum' },
  { id: 3, value: '3', label: '已过期', statsKey: 'expiredNum' },
  { id: 4, value: '4', label: '已终止', statsKey: 'terminationNum' },
];

// 厂商联 平台求购信息-求购分类
export const seekPurchaseType = [
  { id: 0, value: '', label: '全部' },
  { id: 1, value: 1, label: '直接求购' },
  { id: 2, value: 2, label: '指定工厂' },
  { id: 3, value: 3, label: '指定商品' },
];

// #endregion

// #region 系统通用
// 渠道类型
export const channelTypes = [
  {
    label: '全部',
    value: '',
  },
  {
    label: 'WEB',
    value: 1,
  },
  {
    label: 'APP',
    value: 2,
  },
  {
    label: 'WAP',
    value: 3,
  },
];

// #endregion

// #region 厂商联管理 会员标签=>会员等级
export const memberLevelList = [
  {
    id: 1,
    label: 'M1',
    value: 'M1',
  },
  {
    id: 2,
    label: 'M2',
    value: 'M2',
  },
  {
    id: 3,
    label: 'M3',
    value: 'M3',
  },
];
// #endregion

// #region 英文版展示位置列表
export const showTypeList = [
  {
    label: '中文系统',
    value: 1,
  },
  {
    label: '英文系统',
    value: 2,
  },
  {
    label: '中英文都有',
    value: 3,
  },
];
// #endregion
